import React from "react";
import { useNavigate } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";

const Button = styled.button`
  ${tw`bg-blue-500 hover:bg-blue-700 text-white font-light z-10 p-3 float-right mt-64 fixed right-0 hover:rounded transition-colors`};
  top: 50%;
  @media screen and (max-width: 780px) {
    & {
      top: 35%;
    }
  }
`;
const ContactUsButton = () => {
  const navigate = useNavigate();
  return (
    <Button onClick={() => navigate("/", { state: "contact" })}>
      <span className="text-lg"> &#9993; </span>Contact us
    </Button>
  );
};

export default ContactUsButton;
